import React, { FC } from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import PermIdentityOutlinedIcon from '@material-ui/icons/PermIdentityOutlined'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined'

import { components } from '@plandi/common/src/generated'
import {
  dateFormatMask,
  diffDateToNow,
  format,
  useLocale,
  useTranslation
} from '@plandi/common'
import { useProfileDetailsStyles } from './profile-details.styles'

type ProfileInfoProps = {
  type: string | string[] | undefined
  profileFreelancer?: components['schemas']['ProfileSpecialistMeResource']
  profileCompany?: components['schemas']['ProfileCompanyMeResource']
  profileFactory?: components['schemas']['ProfileFactoryMeResource']
}

export const ProfileInfo: FC<ProfileInfoProps> = ({
  type,
  profileFreelancer,
  profileCompany,
  profileFactory
}) => {
  const classes = useProfileDetailsStyles()
  const locale = useLocale()
  const { data: translation } = useTranslation()

  const renderInfo = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {translation?.['user-info']?.['basic-information'] ??
            'Основная информация'}
        </Typography>
        {((type === 'freelancer' && profileFreelancer?.location?.country) ||
          (type === 'company' && profileCompany?.location?.country) ||
          ((type === 'factory' || !type) &&
            profileFactory?.location?.country)) && (
          <div className={classes.textWrap}>
            <HomeOutlinedIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component="span"
            >
              {translation?.country}:{' '}
              <span>
                {type === 'freelancer'
                  ? profileFreelancer?.location?.country?.name
                  : type === 'company'
                  ? profileCompany?.location?.country?.name
                  : profileFactory?.location?.country?.name}
              </span>
            </Typography>
          </div>
        )}
        {((type === 'freelancer' && profileFreelancer?.location?.city) ||
          (type === 'company' && profileCompany?.location?.city) ||
          ((type === 'factory' || !type) &&
            profileFactory?.location?.city)) && (
          <div className={classes.textWrap}>
            <HomeOutlinedIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component="span"
            >
              {translation?.city}:{' '}
              <span>
                {type === 'freelancer'
                  ? profileFreelancer?.location?.city?.name
                  : type === 'company'
                  ? profileCompany?.location?.city?.name
                  : profileFactory?.location?.city?.name}
              </span>
            </Typography>
          </div>
        )}
        {type === 'freelancer' && profileFreelancer?.birthday && (
          <div className={classes.textWrap}>
            <PermIdentityOutlinedIcon
              fontSize="small"
              className={classes.icon}
            />
            <Typography
              className={classes.text}
              variant="body2"
              component="span"
            >
              {translation?.['job-site']?.['specialist-page'].age}:{' '}
              <span>{diffDateToNow(profileFreelancer.birthday, true)}</span>
            </Typography>
          </div>
        )}
        {(profileFreelancer?.createdAt ||
          profileCompany?.createdAt ||
          profileFactory?.createdAt) && (
          <div className={classes.textWrap}>
            <ErrorOutlinedIcon fontSize="small" className={classes.icon} />
            <Typography variant="body2" component="span">
              {locale === 'ru' ? 'Зарегистрирован от' : 'Registered'}{' '}
              <span>
                {dateFormatMask(
                  type === 'freelancer'
                    ? profileFreelancer?.createdAt ?? ''
                    : type === 'company'
                    ? profileCompany?.createdAt ?? ''
                    : profileFactory?.createdAt ?? '',
                  format.shortFullDate
                )}
              </span>
            </Typography>
          </div>
        )}
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderInfo()}</CardContent>
    </Card>
  )
}
